import { CurrencyCode, Localisation, TimeFormat } from 'app/model/enums/region-variant';
import { RegionVariantDetails } from '../region-variant';

export const regionVariantUK: RegionVariantDetails = {
  text: {
    general: {
      tax_code: {
        title_case: 'VAT Rate',
        sentence_case: 'VAT rate',
      },
      grid_headers: {
        value_dollars: 'Total',
        actual_dollars: 'Actual Amount',
        total_dollars: 'Total Amount',
        capacity_dollars: 'Capacity Amount',
        chargeable_dollars: 'Chargeable',
        nonchargeable_dollars: 'Non-Chargeable',
        fees: 'WIP',
        tax: 'VAT',
        job_type: 'Type',
      },
      filters: {
        job_type: {
          label_selected: 'Type',
          label_unselected: 'Select type',
        },
      },
    },
    settings: {
      positions: {
        title: 'SIP9 Settings',
        subtitle: 'Set positions available for users and their associated SIP9 roles',
        icon: 'heroicons_outline:user-group',
      },
    },
    time_entry: {
      header_date_format: 'dd MMM',
      rate: 'Rate ({{currency}} / Hour)',
    },
    disbursements: {
      grid_headers: {
        amount_ex_tax: 'Net Amount',
        billed_ex_tax: 'Invoiced Net Amount',
      },
      drawer: {
        amount: 'Net Amount',
        tax: 'VAT Amount',
        total: 'Gross Amount',
        amount_short: 'Net',
        tax_short: 'VAT',
        total_short: 'Gross',
      },
    },
    time_vs_billed: {
      grid_headers: {
        posted_total: 'Post WIP Total',
        unposted_total: 'Unpost WIP Total',
        billed_total: 'Invoiced WIP Total',
        total: 'WIP Total',
        posted_hours: 'Posted Hours',
        unposted_hours: 'Unposted Hours',
        hours: 'Hours',
      },
    },
    job_activity: {
      grid_headers: {
        dollars_per_hour_ex_tax: 'Charge Out Rate',
      },
    },
    job_type_filters: {
      billing: false,
      setup_approvals: false,
    },
    invoice: {
      tax: 'VAT',
      taxInvoice: 'Invoice',
      taxInvoiceDetails: 'Invoice Details',
      nominalTaxCredit: 'Nominal Tax Credit',
    },
  },
  show: {
    disbursements: {
      timeUnits: false,
      grid_columns: {
        taxCode: false,
      },
    },
    invoices: {
      nominalInvoices: false,
      creditNotes: true,
      billDetailLimits: true,
      output_fields: {
        abn: false,
      },
    },
    reports: {
      sip9: true,
      text_enter_filter_criteria: false,
    },
    addMenu: {
      addJob: false,
      addUser: true,
    },
    timeCategoryDefaults: true,
    companySearch: false,
  },
  flag: {
    time_entry: {
      notes_required: true,
    },
  },
  timeFormattingForceHours: {
    timeReview: true,
    reports: true,
    invoices: true,
  },
  defaultCurrencyCode: CurrencyCode.GBP,
  defaultLocalisation: Localisation.enGB,
  defaultTimeEntryMethod: 'conventional',
  timeFormat: TimeFormat.TwentyFourHour,
  regionTax: 'VAT',
};
